module.exports = __webpack_public_path__ + "img/bg-top-partner-plan.3b3701ce.png";